import { NavLink, useLocation } from "react-router-dom";
import { FiSearch, FiBriefcase, FiUser, FiSettings, FiBook, FiMessageSquare } from "react-icons/fi";

import { useComponentTranslation } from "@/services/i18n";

const translations = {
  en: {
    sidebar: {
      explore: "Explore jobs",
      my_applications: "My Applications",
      chat: "Chat",
      profile: "Profile",
      settings: "Settings",
      "personal-information": "Personal Information",
      experiences: "Experiences",
      preferences: "Preferences",
      skills: "Skills",
      training: "Training",
      logout: "Logout",
      logout_success: "Logged out successfully",
      logout_error: "Failed to logout",
    },
  },
  fr: {
    sidebar: {
      explore: "Explorer les offres",
      my_applications: "Mes candidatures",
      chat: "Chat",
      profile: "Profil",
      settings: "Paramètres",
      "personal-information": "Informations personnelles",
      experiences: "Expériences",
      preferences: "Préférences",
      skills: "Compétences",
      training: "Formation",
      logout: "Déconnexion",
      logout_success: "Déconnexion réussie",
      logout_error: "Échec de la déconnexion",
    },
  },
};

const MENU_ITEMS = [
  {
    to: "/candidate",
    icon: FiSearch,
    label: "sidebar.explore",
    exact: true,
  },
  {
    to: "/candidate/application",
    icon: FiBriefcase,
    label: "sidebar.my_applications",
  },
  // {
  //   to: "/candidate/training",
  //   icon: FiBook,
  //   label: "sidebar.training",
  // },
  {
    to: "/candidate/chat",
    icon: FiMessageSquare,
    label: "sidebar.chat",
  },
  {
    to: "/candidate/profile",
    icon: FiUser,
    label: "sidebar.profile",
  },
  // {
  //   to: "/candidate/settings",
  //   icon: FiSettings,
  //   label: "sidebar.settings",
  // },
];

const Sidebar = () => {
  const { t } = useComponentTranslation(translations);
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/candidate") {
      return location.pathname === "/candidate";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="fixed left-0 top-0 h-full w-56 bg-secondary border-r border-gray-200 flex flex-col z-30">
      {/* Logo */}
      <div className="px-6 pt-6 pb-2">
        <NavLink to="/candidate" className="flex flex-col">
          <span className="text-xl font-extrabold text-gray-900">Jobego</span>
          <span className="text-xs text-gray-500 font-medium mt-0.5">Candidates</span>
        </NavLink>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto p-4">
        <ul>
          {MENU_ITEMS.map((item, index) => {
            if (item.type === "separator") {
              return (
                <li key={`separator-${index}`} className="my-4">
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider text-nowrap mr-4">{t(item.label)}</span>
                    <div className="h-px bg-gray-200 w-full flex-1" />
                  </div>
                </li>
              );
            }

            const Icon = item.icon;
            const active = isActive(item.to);
            return (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.exact}
                  className={`group flex items-center gap-3 p-2 rounded-lg text-sm transition-all duration-200 ${
                    active ? "bg-primary text-white shadow-sm font-medium" : "text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  <Icon className={`w-5 h-5 ${!active ? "group-hover:text-black" : ""}`} />
                  <span className={`${!active ? "group-hover:text-black" : ""}`}>{t(item.label)}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
